import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingSpinner } from '@/components/LoadingSpinner';

// Lazy load AuthProvider to avoid loading Firebase on public pages
const AuthProvider = lazy(() =>
  import('@/lib/sdk/accounts/context').then(module => ({
    default: module.AuthProvider
  }))
);

const AdminAuthWrapper = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </Suspense>
  );
};

export default AdminAuthWrapper;
